// Лимит длины текста дизайн-блока прямо в редакторе (kkc82): раньше был только
// счётчик, ввод шёл дальше, бэк отбивал PUT блока 422 — и не сохранялось ничего,
// даже то, что влезало. Длина — как у бэка и счётчика: очищенный html (`designTextLength`).
import { Extension, getHTMLFromFragment } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { toast } from 'sonner'
import { messagesNow } from '@/i18n'
import { messages } from '@/features/editor/components/studio/messages'
import { designTextLength } from '@/features/editor/lib/designHtml'

/** Мета транзакции, которую лимит пропускает: подстановка текста с сервера, не ввод автора. */
export const SKIP_TEXT_LIMIT = 'designTextLimitSkip'

export const DesignTextLimit = Extension.create<{ limit: number }>({
  name: 'designTextLimit',
  addOptions: () => ({ limit: Infinity }),
  addProseMirrorPlugins() {
    const { limit } = this.options
    const { schema } = this.editor
    const lengthOf = (doc: Parameters<typeof getHTMLFromFragment>[0]) =>
      designTextLength(getHTMLFromFragment(doc, schema))
    return [
      new Plugin({
        key: new PluginKey('designTextLimit'),
        // Правку, которая выводит за лимит, не пускаем. Сокращение пропускаем всегда:
        // текст, пришедший длиннее (MCP, старые данные), автор должен суметь урезать.
        filterTransaction: (tr, state) => {
          if (!tr.docChanged || tr.getMeta(SKIP_TEXT_LIMIT)) return true
          const next = lengthOf(tr.doc.content)
          if (next <= limit || next <= lengthOf(state.doc.content)) return true
          // Вставка молча «не срабатывала» — автор думает, что она сломана. Набор с клавиатуры
          // за лимитом и так виден (курсор не двигается), тост на каждый символ был бы шумом.
          if (tr.getMeta('uiEvent') === 'paste') {
            toast.error(messagesNow(messages).designTextTooLong, { id: 'design-text-too-long' })
          }
          return false
        },
      }),
    ]
  },
})
